module.exports = __webpack_public_path__ + "media/brands/belarus-08214f60.png";